module.exports = __webpack_public_path__ + "media/sub2-6-5.eaaea389.mp4";